export function formatPercent(input: string): number {
    const parts = input.split('.');
    const precision = parts.length === 2 ? Math.max(parts[1].length - 2, 0) : 0;
    const factor = Math.pow(10, precision);
    const number = Math.round(parseFloat(input) * 100 * factor) / factor;
    return number;
}
